import Axios from "axios";

export const SelectTopFrs = (a, b, c, d, e) => {
  return (dispatch) => {
    Axios.get(
      `https://www.24-crm.tn/webservice/api/FacFrs?coddos=${a}&serveur=${b}&user=${c}&pwd=${d}&database=${e}`
    ).then((response) => {
      return dispatch({ type: "TOPFRS_SELECT", payload: response.data });
    });
  };
};
